export enum CompanyType {
  B = "Broker",
  V = "ISV & MDV",
  Y = "Provider",
  Z = "Other Institute"
}

export class CompanyTypeClass {
  static list(){
    return [
      {"key" : "B", "value" : CompanyType.B},
      {"key" : "V", "value" : CompanyType.V},
      {"key" : "Y", "value" : CompanyType.Y},
      {"key" : "Z", "value" : CompanyType.Z}
    ]
  }

  static getObjectFromEnum(companyType: CompanyType){
    return CompanyTypeClass.list().filter(object => object.key == companyType)[0]
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/models/company-type.ts